import { render, staticRenderFns } from "./advertising_page.vue?vue&type=template&id=7883cc2c&scoped=true"
import script from "./advertising_page.vue?vue&type=script&lang=js"
export * from "./advertising_page.vue?vue&type=script&lang=js"
import style0 from "./advertising_page.vue?vue&type=style&index=0&id=7883cc2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7883cc2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7883cc2c')) {
      api.createRecord('7883cc2c', component.options)
    } else {
      api.reload('7883cc2c', component.options)
    }
    module.hot.accept("./advertising_page.vue?vue&type=template&id=7883cc2c&scoped=true", function () {
      api.rerender('7883cc2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/advertising_page.vue"
export default component.exports